import { AxiosError } from 'axios';

import { unhandledRequest } from 'api/request';

export type TriggerData = {
  name: string;
  email: string;
  department: { value: string; label: string }[];
  ssn: string;
  firstWorkday: Date;
};

export type InitialData = {
  name: string;
  email: string;
  department: { value: string; label: string }[] | string;
  ssn: string;
  firstWorkday: Date;
};

export type TriggerDataCreate = TriggerData & {
  save?: boolean;
};

export type ApplicationData = {
  data?: TriggerData;
  sentBy?: string;
  created?: Date;
};

export type FormResponse = {
  name: string;
  description: string;
  title: string;
  isDone: boolean;
  departmentOptions: { value: string; label: string }[];
  integrationData: InitialData;
  applicationData?: ApplicationData;
};

export type SubmitError = AxiosError<{ error: string }>;

export async function getApplicationData(applicationId: string) {
  const response = await unhandledRequest.get<FormResponse>({
    url: `/integrations/learnworlds/${applicationId}`,
  });
  return response.data;
}

export async function createUser(applicationId: string, data: TriggerDataCreate) {
  const response = await unhandledRequest.post({
    url: `/integrations/learnworlds/${applicationId}`,
    data: {
      ...data,
    },
  });
  return response.data;
}
